export default "__VITE_ASSET__C9LhuerZ__"